import { AsyncPipe, NgIf } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ApiService } from "../../api/api.service";
import { PublicPageComponent } from "../../components/public-page/public-page.component";
import { AppQuery } from "../../store/app.query";
import { AppService } from "../../store/app.service";

@Component({
    selector: "nerri-root",
    templateUrl: "root.template.html",
    styleUrls: ["root.style.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [AsyncPipe, MatButtonModule, NgIf, PublicPageComponent, RouterLink, TranslateModule]
})
export class RootComponent implements OnInit {
    public organisation$ = this.appQuery.organisation$;
    public authError$ = this.appQuery.selectAuthError();

    constructor(
        private appQuery: AppQuery,
        private appService: AppService,
        private router: Router,
        private api: ApiService
    ) {}

    public ngOnInit(): void {
        const { authorized } = this.appQuery.getValue();
        if (authorized !== null) {
            return;
        }

        this.appService.loadCurrentAccount().subscribe(() => {
            const { currentAccount } = this.appQuery.getValue();
            if (currentAccount) {
                this.router.navigate(["/dashboard"]);
            }
        });
    }

    public clickLogin(): void {
        this.api.session.login();
    }
}
